export default __webpack_public_path__ + "static/media/dontknow.2a5c6eb7.svg";